var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-form",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "my-md-1", attrs: { md: "6", cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Transaction Date",
                            "label-for": "transactionDateInput",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "transactionDateInput", disabled: "" },
                            model: {
                              value: _vm.journalEntryId.date,
                              callback: function ($$v) {
                                _vm.$set(_vm.journalEntryId, "date", $$v)
                              },
                              expression: "journalEntryId.date",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "my-md-1", attrs: { md: "6", cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Reference",
                            "label-for": "referenceInput",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "referenceInput",
                              type: "text",
                              readonly: "",
                            },
                            model: {
                              value: _vm.journalEntryId.refID,
                              callback: function ($$v) {
                                _vm.$set(_vm.journalEntryId, "refID", $$v)
                              },
                              expression: "journalEntryId.refID",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        { staticClass: "mt-3" },
        [
          _vm.loading
            ? _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning", block: "" },
              })
            : _vm._e(),
          !_vm.loading
            ? _c("b-table", {
                attrs: {
                  responsive: "",
                  items: _vm.journal.journalEntryLines,
                  fields: _vm.tableFields,
                  striped: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(ACCOUNT)",
                      fn: function (row) {
                        return [
                          _c("b-form-select", {
                            attrs: {
                              options: _vm.optionsAccount,
                              disabled: "",
                            },
                            model: {
                              value: row.item.accountID,
                              callback: function ($$v) {
                                _vm.$set(row.item, "accountID", $$v)
                              },
                              expression: "row.item.accountID",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(DEBIT)",
                      fn: function (row) {
                        return [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              disabled: row.item.credit !== "",
                            },
                            model: {
                              value: row.item.debit,
                              callback: function ($$v) {
                                _vm.$set(row.item, "debit", $$v)
                              },
                              expression: "row.item.debit",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(CREDIT)",
                      fn: function (row) {
                        return [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              disabled: row.item.debit !== "",
                            },
                            model: {
                              value: row.item.credit,
                              callback: function ($$v) {
                                _vm.$set(row.item, "credit", $$v)
                              },
                              expression: "row.item.credit",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(CONTACT)",
                      fn: function (row) {
                        return [
                          _c("b-form-select", {
                            attrs: {
                              options: _vm.optionsContact,
                              disabled: "",
                            },
                            model: {
                              value: row.item.contactID,
                              callback: function ($$v) {
                                _vm.$set(row.item, "contactID", $$v)
                              },
                              expression: "row.item.contactID",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(DESCRIPTION)",
                      fn: function (row) {
                        return [
                          _c("b-form-textarea", {
                            attrs: { rows: "3", disabled: "" },
                            model: {
                              value: row.item.description,
                              callback: function ($$v) {
                                _vm.$set(row.item, "description", $$v)
                              },
                              expression: "row.item.description",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(AMOUNT)",
                      fn: function (row) {
                        return [
                          _c("span", [_vm._v(_vm._s(_vm.getAmount(row)))]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4147402844
                ),
              })
            : _vm._e(),
          !_vm.loading
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _c("div", { staticClass: "py-1 px-2 d-flex" }, [
                        _c("h5", [_vm._v("Total Debit:")]),
                        _c("span", { staticClass: "ml-5" }, [
                          _vm._v(_vm._s(_vm.getTotalDebit)),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _c("div", { staticClass: "py-1 px-2 d-flex" }, [
                        _c("h5", [_vm._v("Total Credit:")]),
                        _c("span", { staticClass: "ml-5" }, [
                          _vm._v(_vm._s(_vm.getTotalCredit)),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }